import { NgModule } from '@angular/core';
import {
    FaIconLibrary,
    FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';

import {
    faArrowLeft as farArrowLeft,
    faBadgeCheck as farBadgeCheck,
    faBuilding as farBuilding,
    faCircleCheck as farCircleCheck,
    faEnvelope as farEnvelope,
    faLocationDot as farLocationDot,
    faLock as farLock,
    faPhone as farPhone,
    faUser as farUser,
    faLightbulb as farLightBulb,
    faMagnifyingGlassChart as farMagnifyingGlassChart,
    faChalkboardUser as farChalkboardUser,
    faHandshakeAngle as farHandshakeAngle,
    faLinkHorizontal as farLinkHorizontal,
    faJoystick as farJoystick,
    faTags as farTags,
    faCar as farCar,
    faRocketLaunch as farRocketLaunch,
    faShieldQuartered as farShieldQuartered,
    faTrain as farTrain,
    faTruck as farTruck,
    faHouseMedical as farHouseMedical,
    faGears as farGears,
    faGear as farGear,
    faCertificate as farCertificate,
    faChartSimple as farChartSimple,
    faChartPieSimple as farChartPieSimple,
    faCalculatorSimple as farCalculatorSimple,
    faLeaf as farLeaf,
    faChartNetwork as farChartNetwork,
    faEarthEurope as farEarthEurope,
    faList as farList,
    faChartMixed as farChartMixed,
    faFileChartPie as farFileChartPie,
    faRankingStar as farRankingStar,
    faUserGroup as farUserGroup,
    faFileLock as farFileLock

} from '@fortawesome/pro-regular-svg-icons';
import {
    faCheck as fasCheck,
    faInfo as fasInfo,
    faXmark as fasXmark,
    faChalkboardUser as fasChalkboardUser,
    faHandshakeAngle as fasHandshakeAngle,
    faChartLineUp as fasChartLineUp,
    faLaptop as fasLaptop,
    faCoins as fasCoins,
    faLightbulb as fasLightBulb,
    faScreenUsers as fasScreenUsers,
    faChessKnightPiece as fasChessKnightPiece,
    faBallotCheck as fasBallotCheck,
    faChartMixed as fasChartMixed,
    faFileContract as fasFileContract,
    faBullseyePointer as fasBullseyePointer,
    faToolbox as fasToolbox,
    faChalkboardTeacher as fasChalkboardTeacher,
    faChartPie as fasChartPie,
    faCircleExclamation as fasCircleExclamation,
    faList as fasList,
    faFilters as fasFilters,
    faUsersGear as fasUsersGear,
    faMagnifyingGlassChart as fasMagnifyingGlassChart,
    faChartSimpleHorizontal as fasChartSimpleHorizontal,
    faRectanglesMixed as fasRectanglesMixed,
    faFileMagnifyingGlass as fasFileMagnifyingGlass,
    faChartSimple as fasChartSimple,
    faHandHoldingSeedling as fasHandHoldingSeedling,
    faFileExport as fasFileExport,
    faEye as fasEye,
    faTimer as fasTimer,
    faFileChartColumn as fasFileChartColumn,
    faGear as fasGear,
    faDatabase as fasDatabase,
    faGlobe as fasGlobe,
    faSquarePollHorizontal as fasSquarePollHorizontal,
    faUserCheck as fasUserCheck,
    faHandsHoldingCircle as fasHandsHoldingCircle,
    faSliders as fasSliders,
    faMagnifyingGlass as fasMagnifyingGlass,
    faFolderTree as  fasFolderTree,
    faChartTreeMap as fasChartTreeMap,
    faGears as fasGears,
    faUniversalAccess as fasUniversalAccess,
    faChartNetwork as fasChartNetwork,
    faEarthEurope as fasEarthEurope,
    faShapes as fasShapes,
    faSlidersUp as fasSlidersUp,
    faUserGroup as fasUserGroup,
    faRectangleVerticalHistory as faRectangleVerticalHistory,
    faRankingStar as fasRankingStar,
    faCommentsQuestion as fasCommentsQuestionCheck,
    faCircleInfo as fasCircleInfo,
    faRadar as fasRadar,
    faFileImport as fasFileImport,
    faCalculatorSimple as fasCalculatorSimple,
    faMemoCircleInfo as fasMemoCircleInfo,
    faCodeCompare as fasCodeCompare,
    faHandHoldingHand as fasHandHoldingHand,
    faShare as fasShare,
    faShieldHalved as fasShieldHalved,
    faLightbulbOn as fasLightbulbOn,
    faShieldCheck as fasShieldCheck,
    faCertificate as fasCertificate,
    faFiles as fasFiles,
    faFingerprint as fasFingerprint

} from '@fortawesome/pro-solid-svg-icons';

@NgModule({
    imports: [
        FontAwesomeModule
    ],
    exports: [
        FontAwesomeModule
    ]
})
export class FontCommonModule {
    constructor(library: FaIconLibrary) {
        library.addIcons(
            farArrowLeft,
            farBadgeCheck,
            farBuilding,
            farCircleCheck,
            farEnvelope,
            farLocationDot,
            farLock,
            farPhone,
            farUser,
            farJoystick,
            farTags,
            farChartSimple,
            farChartPieSimple,
            fasCheck,
            fasInfo,
            fasXmark,
            farLightBulb,
            farMagnifyingGlassChart,
            farChalkboardUser,
            farHandshakeAngle,
            farLinkHorizontal,
            farRocketLaunch,
            farShieldQuartered,
            farTrain,
            farTruck,
            farCar,
            farHouseMedical,
            farGears,
            farCertificate,
            farCalculatorSimple,
            farLeaf,
            farChartNetwork,
            farEarthEurope,
            farList,
            farChartMixed,
            farFileChartPie,
            farRankingStar,
            farGear,
            farUserGroup,
            farFileLock,
            fasChalkboardUser,
            fasHandshakeAngle,
            fasChartLineUp,
            fasLaptop,
            fasCoins,
            fasLightBulb,
            fasScreenUsers,
            fasChessKnightPiece,
            fasBallotCheck,
            fasChartMixed,
            fasFileContract,
            fasBullseyePointer,
            fasToolbox,
            fasChalkboardTeacher,
            fasChartPie,
            fasCircleExclamation,
            fasList,
            fasFilters,
            fasUsersGear,
            fasMagnifyingGlassChart,
            fasChartSimpleHorizontal,
            fasRectanglesMixed,
            fasFileMagnifyingGlass,
            fasChartSimple,
            fasHandHoldingSeedling,
            fasFileExport,
            fasEye,
            fasTimer,
            fasFileChartColumn,
            fasGear,
            fasDatabase,
            fasGlobe,
            fasSquarePollHorizontal,
            fasUserCheck,
            fasHandsHoldingCircle,
            fasSliders,
            fasMagnifyingGlass,
            fasFolderTree,
            fasChartTreeMap,
            fasGears,
            fasUniversalAccess,
            fasChartNetwork,
            fasEarthEurope,
            fasShapes,
            fasSlidersUp,
            fasUserGroup,
            faRectangleVerticalHistory,
            fasRankingStar,
            fasCommentsQuestionCheck,
            fasCircleInfo,
            fasRadar,
            fasFileImport,
            fasCalculatorSimple,
            fasMemoCircleInfo,
            fasCodeCompare,
            fasHandHoldingHand,
            fasShare,
            fasShieldHalved,
            fasLightbulbOn,
            fasShieldCheck,
            fasCertificate,
            fasFiles,
            fasFingerprint
        );
    }
}
